import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";

@Component({
  selector: "app-common-datas",
  templateUrl: "./common-datas.component.html",
  styleUrls: ["./common-datas.component.scss"]
})
export class CommonDatasComponent implements OnInit {
  constructor(private router: Router) {}

  ngOnInit(): void {}


  noData(title: string) {
    this.router.navigateByUrl("/no-data", { state: { title: title } });
  }
}
